import React, { useState, useContext } from "react";
import { toast } from "react-toastify";
import { logActivity } from "../../utils/LogActivity";
import { AuthContext } from "../../Context/AuthContext";

const inputStyle = { width: "100%", padding: "9px 12px", border: "1.5px solid #E2E8F0", borderRadius: 8, fontSize: 13, color: "#1A202C", background: "#fff", outline: "none", transition: "border-color 0.2s" };
const labelStyle = { fontSize: 12, fontWeight: 600, color: "#2D3748", marginBottom: 6, display: "block" };

const EditState = ({ state, onClose }) => {
  const [stateName, setStateName] = useState(state.stateName);
  const [stateCode, setStateCode] = useState(state.stateCode);
  const [errors, setErrors] = useState({});
  const { userId } = useContext(AuthContext);
  const Api = process.env.REACT_APP_API;

  const validate = () => {
    const errs = {};
    if (!stateName) errs.stateName = "State name is required";
    if (!stateCode) errs.stateCode = "State code is required";
    else if (stateCode.length !== 2) errs.stateCode = "State code must be 2 characters";
    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); toast.error("Please fix the errors"); return; }

    try {
      const response = await fetch(`${Api}/api/states/${state._id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ stateName, stateCode }),
      });
      if (response.ok) {
        toast.success("Updated Successfully");
        await logActivity(userId, "Edited State", "Edit State Page", Api);
        onClose();
      } else {
        toast.error("Error updating");
      }
    } catch {
      toast.error("Error updating");
    }
  };

  const focus = (e) => (e.target.style.borderColor = "#4CAF50");
  const blur = (e) => (e.target.style.borderColor = "#E2E8F0");

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1050, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ background: "#fff", borderRadius: 12, width: "100%", maxWidth: 460, boxShadow: "0 20px 60px rgba(0,0,0,0.3)", overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: "#fff" }}>Edit State</span>
          <button onClick={onClose} style={{ background: "rgba(255,255,255,0.2)", border: "none", borderRadius: 6, color: "#fff", cursor: "pointer", fontSize: 16, width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
        </div>
        <div style={{ padding: 24 }}>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>State Name <span style={{ color: "#E53E3E" }}>*</span></label>
              <input type="text" placeholder="Enter state name" value={stateName}
                onChange={(e) => setStateName(e.target.value)} style={inputStyle} onFocus={focus} onBlur={blur} />
              {errors.stateName && <div style={{ color: "#E53E3E", fontSize: 11, marginTop: 4 }}>{errors.stateName}</div>}
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={labelStyle}>State Code <span style={{ color: "#E53E3E" }}>*</span></label>
              <input type="text" placeholder="Enter state code (2 chars)" value={stateCode}
                onChange={(e) => setStateCode(e.target.value)} style={inputStyle} onFocus={focus} onBlur={blur} />
              {errors.stateCode && <div style={{ color: "#E53E3E", fontSize: 11, marginTop: 4 }}>{errors.stateCode}</div>}
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button type="submit" style={{ display: "inline-flex", alignItems: "center", gap: 7, padding: "10px 20px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)", color: "#fff", border: "none", borderRadius: 9, fontSize: 13, fontWeight: 700, cursor: "pointer", boxShadow: "0 3px 10px rgba(46,125,50,0.3)" }}>
                <i className="mdi mdi-content-save" /> Update
              </button>
              <button type="button" onClick={onClose} style={{ padding: "10px 20px", background: "#F7FAFC", color: "#4A5568", border: "1px solid #E2E8F0", borderRadius: 9, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditState;
